import { Box, Typography, Zoom } from '@mui/material';
import UserAvatar from './UserAvatar';

const PODIUM_COLORS = {
  first: {
    light: '#FFD700',
    dark: '#FFC800',
    shadow: 'rgba(255, 215, 0, 0.3)'
  },
  second: {
    light: '#C0C0C0',
    dark: '#A9A9A9',
    shadow: 'rgba(192, 192, 192, 0.3)'
  },
  third: {
    light: '#CD7F32',
    dark: '#B87333',
    shadow: 'rgba(205, 127, 50, 0.3)'
  }
};

const PodiumPlace = ({ player, position, delay }) => {
  const positionNumbers = {
    first: '1',
    second: '2',
    third: '3'
  };

  const podiumHeight = {
    first: 200,
    second: 160,
    third: 120
  };

  const avatarSize = {
    first: 120,
    second: 100,
    third: 80
  };

  const marginTop = {
    first: 0,
    second: 10,
    third: 20
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '0 1rem',
      position: 'relative',
      marginTop: marginTop[position]
    }}>
      <Zoom in={true} style={{ transitionDelay: `${delay}ms` }}>
        <Box sx={{
          height: podiumHeight[position],
          width: 160,
          background: `linear-gradient(45deg, ${PODIUM_COLORS[position].light}, ${PODIUM_COLORS[position].dark})`,
          borderRadius: '8px 8px 0 0',
          position: 'relative',
          boxShadow: `0 4px 20px ${PODIUM_COLORS[position].shadow}`,
          zIndex: position === 'first' ? 2 : 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {position === 'first' && (
            <Typography sx={{
              position: 'absolute',
              top: -100,
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '60px !important',
              filter: 'drop-shadow(0 4px 10px rgba(255, 215, 0, 0.5))',
              animation: 'float 3s ease-in-out infinite',
              zIndex: 4,
              '@keyframes float': {
                '0%, 100%': {
                  transform: 'translateX(-50%) translateY(0)'
                },
                '50%': {
                  transform: 'translateX(-50%) translateY(-10px)'
                }
              }
            }}>
              👑
            </Typography>
          )}
          
          <Box sx={{
            position: 'absolute',
            top: -40,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 3
          }}>
            {player ? (
              <UserAvatar
                src={player.hasRpmAvatar ? player.rpmModelUrl?.replace('.glb', '.png') : player.photoURL}
                alt={player.displayName}
                size={avatarSize[position]}
                sx={{
                  border: `2px solid ${PODIUM_COLORS[position].light}`,
                  boxShadow: `0 4px 30px rgba(0, 0, 0, 0.1)`
                }}
                hasRpmAvatar={player.hasRpmAvatar}
                rpmModelUrl={player.rpmModelUrl}
              />
            ) : (
              <Box sx={{
                width: avatarSize[position],
                height: avatarSize[position],
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(5px)'
              }}>
                <Typography sx={{ fontSize: '40px', opacity: 0.5 }}>
                  👤
                </Typography>
              </Box>
            )}
          </Box>

          <Typography variant="h2" sx={{
            position: 'absolute',
            bottom: 10,
            left: '50%',
            transform: 'translateX(-50%)',
            color: 'rgba(255, 255, 255, 0.9)',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
            fontWeight: 'bold',
            fontSize: '4rem !important'
          }}>
            {positionNumbers[position]}
          </Typography>
        </Box>
      </Zoom>

      <Typography sx={{
        marginTop: 2,
        fontWeight: position === 'first' ? 'bold' : 500,
        color: PODIUM_COLORS[position].light,
        fontSize: position === 'first' ? '1.2rem' : position === 'second' ? '1.1rem' : '1rem'
      }}>
        {player?.displayName || 'Kein Teilnehmer'}
      </Typography>

      {player ? (
        <Typography variant="body2" sx={{
          marginTop: 1,
          opacity: 0.8
        }}>
          {player.correctAnswers} richtige {player.correctAnswers === 1 ? 'Antwort' : 'Antworten'}
        </Typography>
      ) : (
        <Box sx={{ height: '24px', marginTop: 1 }} />
      )}
    </Box>
  );
};

export const Podium = ({ winners = [] }) => (
  <Box sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    margin: '1rem auto',
    padding: '0 2rem',
    minHeight: 350,
    position: 'relative'
  }}>
    <PodiumPlace player={winners[1]} position="second" delay={200} />
    <PodiumPlace player={winners[0]} position="first" delay={0} />
    <PodiumPlace player={winners[2]} position="third" delay={400} />
  </Box>
);